const apiUrls = window.appConfig;
const channelId = window._dg_channelId || null;
const isFeatureFlagEnabled = value => value === true || value === "true";
const unlimitedUltimateRecommendationFFlag = (window.reactGlobals?.featureFlag?.unlimitedUltimateRecommendationFFlag == "true" ? true : false);

const isMdot = channelId === 'VZW-DOTCOM-MOB';
const isNative = channelId === 'VZW-MFA';

const isDesktop = channelId === "VZW-DOTCOM";
const isTab = channelId === "VZW-DOTCOM-TAB";
const intlBaseUrl = window._kt_intlBaseUrl;
const  L2WebpunchoutUrl = window.L2WebpunchoutUrl;
const  SessionIdGlobal = window._dg_sessid;
const apiHostUrl = window.env === 'dev' ? 'http://localhost:8000/api' : window.location.origin;
const unauth = window.location.pathname.indexOf("/nos/") > -1;
const isACSS = window._dg_clientId == "VZW-ACSS" ? true : false
const isPOS = window._dg_clientId == "VZW-NETACE" ? true : false
const emptyRequestErrorFFlag = (window.reactGlobals?.featureFlag?.emptyRequestErrorFFlag == "true" ? true : false);
const plansPageContinueButtonFFlag = (window.reactGlobals?.featureFlag?.plansPageContinueButtonFFlag == "true" ? true : false);
const webMcpIntlTravelPlanFFlag = isFeatureFlagEnabled(window.reactGlobals?.featureFlag?.webMcpIntlTravelPlanFFlag);
const isInIframe = window.self !== window.top;

export { apiUrls , isMdot, isNative, isDesktop, isInIframe, isTab, intlBaseUrl, apiHostUrl, unauth, isACSS,isPOS, L2WebpunchoutUrl, unlimitedUltimateRecommendationFFlag, SessionIdGlobal, emptyRequestErrorFFlag, plansPageContinueButtonFFlag, webMcpIntlTravelPlanFFlag};

